import { useContext, useMemo } from 'react'
import { Experiments } from 'constants/experiments'
import CurrencyContext from 'contexts/currencyContext'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import useExperiment from 'hooks/Experiments/useExperiment'
import { isHotel } from 'lib/offer/offerTypes'

import { getPrefetchFlightsFromOfferSearchKeys } from './prefetchFlightsFromOfferUtils'
import useInvalidateStalePrefetchedFlightSearches from './useInvalidateStalePrefetchedFlightSearches'

export default function useInvalidateStalePrefetchedFlightsFromOffer() {
  const offerPageState = useContext(OfferPageStateContext)
  const currentCurrency = useContext(CurrencyContext)
  const { isAnyVariant: prefetchFlights } = useExperiment(Experiments.croPrefetchFlightsFromOffer, { canActivate: false })
  const {
    airport,
    checkInDate,
    checkOutDate,
    duration,
    fareClass,
    rooms,
  } = offerPageState
  const offer = offerPageState.bedbankOffer ?? offerPageState.offer
  const flightSearchKeys = useMemo(() => {
    if (!prefetchFlights || !offer || !isHotel(offer)) return []

    return getPrefetchFlightsFromOfferSearchKeys({
      offer,
      originAirportCode: airport?.code,
      checkInDate,
      checkOutDate,
      duration,
      fareClass,
      rooms,
      currency: currentCurrency,
    })
  }, [airport?.code, checkInDate, checkOutDate, currentCurrency, duration, fareClass, offer, prefetchFlights, rooms])

  return useInvalidateStalePrefetchedFlightSearches(flightSearchKeys)
}
